import ELementContentCustomerDetail from '@/components/sections/builder/elements/body/customer/customer_detail/content';
import ElementSettingCustomerDetail from '@/components/sections/builder/elements/body/customer/customer_detail/setting';
import { CustomerDetailElementDataType } from '@/components/sections/builder/elements/body/customer/customer_detail/type';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: CustomerDetailElementDataType = {
  name: 'Account',
  topPadding: 20,
  bottomPadding: 20,
};

export const ELementPreviewIcon = BetweenHorizontalStart;

const CustomerDetail = {
  type: 'customer_detail',
  group: 'body_customer_detail',
  defaultData,
  PreviewIcon: ELementPreviewIcon,
  Element: ELementContentCustomerDetail,
  Setting: ElementSettingCustomerDetail,
  isImmutable: true,
  maxEntries: 1,
};

export default CustomerDetail;
